module.exports = __webpack_public_path__ + "media/MRI18-ad.e925b85d.mp3";